export enum SocialNetworks {
  linkedin,
  twitter,
  discord,
  telegram,
  reddit,
  instagram,
  tiktok,
}

export enum RestCodes {
  Ok = 200,
  BadRequest = 400,
  NotFound = 404,
  Conflict = 409,
}

export enum UserRole {
  owner = "founder",
  curator = "manager",
  member = "member",
  investor = "investor",
}

export enum SolanaNetwork {
  DEVNET = "https://api.devnet.solana.com",
  MAINNET = "https://api.mainnet-beta.solana.com",
}

export enum SolanaRPC {
  DEVNET = "https://api.devnet.solana.com",
  GENESYS = "https://devnet.genesysgo.net/",
  SOLANA_DAO_DEVNET = "https://api.dao.devnet.solana.com/",
}
export enum ClubAppNetwork {
  DEVNET = "https://beta.monkeventures.io",
  MAINNET = "https://app.monkeventures.io",
}

export enum Role {
  Owner,
  Curator,
  Member,
}

export enum TransactionState {
  Pending,
  Loading,
  Succeeded,
  Failed,
}

export enum ApplicationsInvitations {
  Applications,
  Invitations,
}

export enum SellProposalOption {
  PeerToPeer,
  MagicEden,
}

export enum NftListing {
  AllNfts,
  Bids,
  Sales,
}

export enum ClubAction {
  CastVote,
  CreateDiscussionProposal,
  CreateTreasuryGovernance,
  CreateWithdrawalGovernance,
  CreateTransferGovernance,
  CreateP2PProposal,
  CreateWithdrawalProposal,
  CreateTransferProposal,
  CreateMeProposal,
  SignOffProposal,
  CancelProposal,
  AllowMember,
  CancelP2POffer,
  CancelInvitation,
  Fundraise,
  Distribute,
  SupportClub,
  UpdateMember,
  InitializeStaking,
  StakeTokens,
  CreateFinancialOffer,
  AcceptFinancialOffer,
  CreateSolseaProposal,
  CreateChangeClubConfigGovernance,
  UpdateGovernanceConfig,
  UpdateRoleConfig,
  AddReservedRights,
  UpdateAllocation,
  AddReservedRightsToSelf,
  CanLeave,
}

export enum ClubActionSolana {
  CastVote = "castVote",
  CreateDiscussionProposal = "createDiscussionProposal",
  CreateTreasuryGovernance = "createTreasuryGovernance",
  CreateWithdrawalGovernance = "createWithdrawalGovernance",
  CreateTransferGovernance = "createTransferGovernance",
  CreateP2PProposal = "createP2PProposal",
  CreateWithdrawalProposal = "createWithdrawalProposal",
  CreateTransferProposal = "createTransferProposal",
  CreateMeProposal = "createMeProposal",
  SignOffProposal = "signOffProposal",
  CancelProposal = "cancelProposal",
  AllowMember = "allowMember",
  CancelP2POffer = "cancelP2POffer",
  CancelInvitation = "cancelInvitation",
  Fundraise = "fundraise",
  Distribute = "distribute",
  SupportClub = "supportClub",
  UpdateMember = "updateMember",
  InitializeStaking = "initializeStaking",
  StakeTokens = "stakeTokens",
  CreateFinancialOffer = "createFinancialOffer",
  AcceptFinancialOffer = "acceptFinancialOffer",
  UpdateGovernanceConfig = "updateGovernanceConfig",
  UpdateRoleConfig = "updateRoleConfig",
}

export enum TradedRightType {
  Buy = "buy",
  Sell = "sell",
  BuyReserved = "buyReserved",
  SellReserved = "sellReserved",
}
